"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsnStepToJSON = exports.SsnStepFromJSONTyped = exports.SsnStepFromJSON = void 0;
function SsnStepFromJSON(json) {
    return SsnStepFromJSONTyped(json, false);
}
exports.SsnStepFromJSON = SsnStepFromJSON;
function SsnStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ssn': json['ssn'],
    };
}
exports.SsnStepFromJSONTyped = SsnStepFromJSONTyped;
function SsnStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ssn': value.ssn,
    };
}
exports.SsnStepToJSON = SsnStepToJSON;
//# sourceMappingURL=SsnStep.js.map